import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const reviews = [
  {
    name: "Sophie M.",
    location: "Villeurbanne - Charpennes",
    rating: 5,
    date: "Il y a 2 semaines",
    comment: "Intervention rapide un dimanche soir pour une porte claquée. Le serrurier est arrivé en 25 minutes et a ouvert la porte sans la casser. Prix annoncé au téléphone respecté. Je recommande vivement !"
  },
  {
    name: "Thomas L.",
    location: "Lyon 3 - Part-Dieu",
    rating: 5,
    date: "Il y a 1 mois",
    comment: "Professionnel très compétent pour le changement de ma serrure 3 points après une tentative d'effraction. Travail soigné, conseils de sécurité et tarif honnête. Merci pour votre réactivité !"
  },
  {
    name: "Marie D.",
    location: "Villeurbanne - Gratte-Ciel",
    rating: 5,
    date: "Il y a 3 semaines",
    comment: "Clé cassée dans la serrure à 23h. Service d'urgence impeccable, serrurier très sympa et professionnel. A réussi à extraire le bout de clé et changer le cylindre rapidement. Parfait !"
  },
  {
    name: "Ahmed K.",
    location: "Bron",
    rating: 5,
    date: "Il y a 1 semaine",
    comment: "Excellent service pour l'installation d'une porte blindée. Devis détaillé, pose nickel et conseils personnalisés. Le rapport qualité/prix est top. Je referai appel à eux sans hésiter."
  },
  {
    name: "Julie B.",
    location: "Lyon 6 - Brotteaux",
    rating: 5,
    date: "Il y a 2 mois",
    comment: "Dépannage urgent un samedi matin pour un cylindre bloqué. Intervention en 20 minutes chrono ! Le technicien était très pro et m'a expliqué le problème. Prix correct pour un week-end. Merci !"
  },
  {
    name: "Laurent P.",
    location: "Caluire-et-Cuire",
    rating: 5,
    date: "Il y a 3 semaines",
    comment: "Réparation de mon volet roulant électrique. Diagnostic précis, réparation rapide et garantie sur le travail effectué. Entreprise sérieuse que je recommande pour tous travaux de serrurerie."
  }
];

const Reviews = () => {
  // Calcul de la note moyenne
  const averageRating = (reviews.reduce((acc, review) => acc + review.rating, 0) / reviews.length).toFixed(1);
  
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Ce que disent nos clients</h2>
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-6 w-6 fill-primary text-primary" />
              ))}
            </div>
            <span className="text-2xl font-bold text-foreground">{averageRating}/5</span>
          </div>
          <p className="text-xl text-muted-foreground">
            Basé sur {reviews.length} avis vérifiés
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {reviews.map((review, index) => (
            <Card key={index} className="relative overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-6">
                <Quote className="h-8 w-8 text-primary/20 absolute top-4 right-4" />
                
                <div className="flex gap-1 mb-3">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-primary text-primary" />
                  ))}
                </div>

                <p className="text-muted-foreground mb-4 leading-relaxed">
                  "{review.comment}"
                </p>

                <div className="border-t pt-4">
                  <p className="font-semibold text-foreground">{review.name}</p>
                  <p className="text-sm text-muted-foreground">{review.location}</p>
                  <p className="text-xs text-muted-foreground mt-1">{review.date}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-muted-foreground text-lg mb-4">
            Rejoignez nos centaines de clients satisfaits !
          </p>
          <a 
            href="tel:0695220018" 
            className="inline-block px-8 py-3 bg-primary text-primary-foreground font-semibold rounded-lg hover:bg-primary/90 transition-colors"
          >
            Appelez-nous au 06 95 22 00 18
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
